import firebase from 'firebase/app';
import 'firebase/functions';
import firebaseConfig from './firebaseConfig';

firebase.initializeApp(firebaseConfig);

const functions = firebase.functions();

export const sendProjectMail = functions.httpsCallable('sendProjectMail');
